import { Component, ViewEncapsulation, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
// import { NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { NgbNav } from '@ng-bootstrap/ng-bootstrap';

import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { fadeInOut } from '../../shared/helpers/animations';
import { AuthorizationService, OrderService, SettingsService, StorageManagerService } from '../../shared/services/index';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription, interval } from 'rxjs';
import { TooltipComponent } from '@syncfusion/ej2-angular-popups';
import { DeleteButtonComponent } from '../common/delete-button/delete-button.component';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations/src';
import { Utilities } from '../../shared/services/utilities';
import { EsigModalComponent } from '../common/esig-modal/esig-modal.component';
import { PragmaticValidationService } from '../../shared/services/pragmatic-validation.service';
import { RTCDPragmaticValidation } from '../../shared/models/rtcd_pragmatic_validation.model';
import { ERFormService } from '../../shared/services/er-form-service';
import { FormType } from '../../shared/models/form-type';

@Component({
    selector: 'app-er-form-dashboard',
    templateUrl: './er-form-dashboard.component.html',
    styleUrls: ['./er-form-dashboard.component.scss'],
    animations: [fadeInOut],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})

export class ERFormDashboardComponent implements OnInit, OnDestroy {
  @ViewChild('ERForm_grid')
  public ERForm_grid: GridComponent;
  @ViewChild('drafts_grid')
  public draftsGrid: GridComponent;
  @ViewChild('deliveries_grid')
  public deliverieGrid: GridComponent;
  @ViewChild('tabset', { static: true })
  public tabset: NgbNav;
  @ViewChild('tooltipER')
  public tooltipER: TooltipComponent;
  @ViewChild('tooltipDrafts')
  public tooltipDrafts: TooltipComponent;
  @ViewChild('tooltipDeliveries')
  public tooltipDeliveries: TooltipComponent;
  ERForm_grid_data: any[];
  ERDraftForm_grid_data: any[];
  ERDeliveries_grid_data: any[];
  public initialPage: Object;
  public sortOptions: Object;
  public formatOptions: object;
  public toolbarOptions: Object;
  count_ERForm: number;
  count_draftERForm: number;
  count_deliveriesERForm: number;
  submitted = false;
  public searchForm: UntypedFormGroup;
  errorMessage: string;
  bHasPermission = false;
  sub: Subscription;
  formData: any;
  loading = false;
  activeTab: string;
  public clipmodecolumn = { class: 'e-tooltipcolumn' };
  hasDeletePermission = false;
  selectedErRevisionId: number | undefined;
  @ViewChild('deleteERButton')
  public deleteButton: DeleteButtonComponent;
  @ViewChild('deleteERDraftButton')
  public deleteButtonDrafts: DeleteButtonComponent;
  @ViewChild('deleteERDeliveryButton')
  public deleteButtonDelivery: DeleteButtonComponent;
  @ViewChild('sendToFDAButton')
  public sendToFDAButton: EsigModalComponent;
  selectedERRevisionDraftMode: boolean | undefined;
  selectedERRevisionProductType: string | undefined;
  selectedERRevisionFileName: string | undefined;
  selectedERRevisionVersion: string | undefined;

  needsToPoll: boolean = true;

  constructor (private router: Router, private storageManagerService: StorageManagerService,
    private orderService: OrderService, private toastr: ToastrService,
    private fb: UntypedFormBuilder, private authorizationService: AuthorizationService,
    private activatedRoute: ActivatedRoute, private sanitizer: DomSanitizer,
    private pragmaticValidationService: PragmaticValidationService,
    private settingsService: SettingsService, private erFormService: ERFormService,
    ) {
  }

  ngOnInit(): void {
    this.pollData();

    this.searchForm = this.fb.group({
      searchText: ['', { validators: [Validators.required], updateOn: 'blur' }]
    });
    this.formatOptions = { type: 'dateTime', format: Utilities.getLocaleDateString() + ' hh:mm a' };

    // Check if user has write permission. If no, disable the "Save", "Save a draft" buttons
    this.checkUserPermission();

    // Setup the tool bar configuration
    this.toolbarOptions = this.createCustomToolbarItems(this.hasDeletePermission, this.bHasPermission);
    this.initialPage = { currentPage: 1, pageSize: 25, pageSizes: [25, 50, 75, 100, 'All'] };
    this.formatOptions = { type: 'dateTime', format: Utilities.getLocaleDateString() + ' hh:mm a' };

    this.activeTab = 'ERFormGrid';
  }

  pollData() {
    this.getDeliveryDashboard(true); // Start polling immeditely
    // Poll every minute (60000 milliseconds) only if needsToPoll = true
    this.sub = interval(60000).subscribe(() => {
      if (this.needsToPoll) {
        this.getDeliveryDashboard(false);
      }
    });
  }

  getDeliveryDashboard(isInitialCall) {
    if (isInitialCall) {
      this.formData = this.activatedRoute.snapshot.data['formData'];
      this.gridDataSetup();
    } else {
      this.erFormService.getERDelilveries().subscribe({
        next: (result: any) => {
          if(result && result.data.length) {
            this.processDeliveryDashboardData(result);
            this.gridDataSetup('deliveries');
          }
          else{
            this.loading = false
          }
        }
      })
    }
  }

  processDeliveryDashboardData(result: any) {
    const today: Date = new Date();
    const numberOfDaysAgo: Date = new Date(today.getTime() - parseInt(this.settingsService.pragmaticValidatorAutoRefreshDays, 10) * 24 * 60 * 60 * 1000);

    this.ERDeliveries_grid_data = result.data.map(x => {
      if (x.pragmaticValidationDate) {
        x.pragmaticValidationDate = new Date(x.pragmaticValidationDate);
      }
      return x;
    });

    const filteredDataPragmaticTaskStatusInProgress = this.ERDeliveries_grid_data.filter(item => item.pragmaticTaskStatusCode === 1);
    this.loading = false;
    const filteredDataWithConfigDaysAgo = filteredDataPragmaticTaskStatusInProgress.some(item => {
      const createDate: Date = new Date(item.pragmaticValidationDate);
      return createDate >= numberOfDaysAgo;
    });

    if (!filteredDataWithConfigDaysAgo) {
      this.needsToPoll = false;
    }
    this.formData[1].data = this.ERDeliveries_grid_data;
  }

  gridDataSetup(gridName?: string) {
    // ER form list
    if (this.formData) {
      if (this.formData.error) {
        this.toastr.error(this.formData.error);
        this.formData = null;
      } else if (!Array.isArray(this.formData)) {
        this.toastr.error(this.formData);
        this.formData = null;
      } else {
        if (this.formData[0]) {
          this.ERForm_grid_data = this.formData[0].data.filter(x => x.isDraftMode === false);
          this.count_ERForm = this.ERForm_grid_data.length;
          this.ERDraftForm_grid_data = this.formData[0].data.filter(x => x.isDraftMode === true);
          this.count_draftERForm = this.ERDraftForm_grid_data.length;
        }
      }
    }

    // Merge Deliveries
    if (this.formData && this.formData[1]) {
      this.ERDeliveries_grid_data = this.formData[1].data;
      this.count_deliveriesERForm = this.ERDeliveries_grid_data.length;

      if (this.deliverieGrid) {
        this.deliverieGrid.refresh();
      }
    }
    this.searchForm = this.fb.group({
      searchText: ['', { validators: [Validators.required], updateOn: 'blur' }]
    });
    this.formatOptions = { type: 'dateTime', format: Utilities.getLocaleDateString() + ' hh:mm a' };

    // Check if user has write permission. If no, disable the "Save", "Save a draft" buttons
    this.checkUserPermission();

    // Setup the tool bar configuration
    this.toolbarOptions = this.createCustomToolbarItems(this.hasDeletePermission, this.bHasPermission);
    this.initialPage = { currentPage: 1, pageSize: 25, pageSizes: [25, 50, 75, 100, 'All'] };
    this.formatOptions = { type: 'dateTime', format: Utilities.getLocaleDateString() + ' hh:mm a' };

    this.activeTab = gridName?? 'ERFormGrid';
    this.initTabIndex();
  }

  initTabIndex() {
    (document.activeElement as HTMLElement).blur();

    const main = document.getElementById("firstDiv");

    if (main) {
      main.focus();
    }
  }

  tabChanged(event) {
    this.activeTab = event.nextId;
    // Setup the tool bar configuration
    this.erFormGridRowDeselected();
    this.toolbarOptions = this.createCustomToolbarItems(this.hasDeletePermission, this.bHasPermission);
    this.selectedErRevisionId = undefined;
  }

  pragmaticValidation() {
    let foundItemIndex = this.ERDeliveries_grid_data.findIndex(x => x.fileName === this.selectedERRevisionFileName);
    if (this.ERDeliveries_grid_data[foundItemIndex].pragmaticTaskStatusCode === 1) {
      this.toastr.warning(`Pragmatic validation is already in process.`, '', { closeButton: true });
      return; 
    }

    if (foundItemIndex != -1 ) {
      const customerGuid = this.settingsService.getCustomerGuid();
      let pragmaticData: RTCDPragmaticValidation = {
        formRevisionId: this.ERDeliveries_grid_data[foundItemIndex].erRevisionId,
        sourceFilePath: this.ERDeliveries_grid_data[foundItemIndex].filePath,
        sourceFileName: this.ERDeliveries_grid_data[foundItemIndex].fileName,
        fileType: FormType.ER,
        createUser: this.storageManagerService.read('userData').userguid,
        changeUser: this.storageManagerService.read('userData').userguid,
        customerGuid,
      }

      this.pragmaticValidationService.pragmaticValidation(pragmaticData).subscribe({
        next: (result) => {
          this.ERDeliveries_grid_data[foundItemIndex].pragmaticTaskStatusCode = 1;
          this.ERDeliveries_grid_data[foundItemIndex].pragmaticTaskStatus = 'InProgress';
          this.deliverieGrid.refresh();
          this.needsToPoll = true;
        },
        error: (error) => {
          this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
        },
      });
    }
  }

  getActiveGrid() {
    let grid;

    switch (this.activeTab) {
      case 'drafts':
        grid = this.draftsGrid;
        break;
      case 'deliveries':
        grid = this.deliverieGrid;
        break;
      case 'ERFormGrid':
        grid = this.ERForm_grid;
        break;
    }

    return grid;
  }

  tooltipValue(args) {

    let grid;
    let tooltip: TooltipComponent;

    if (args.target.scrollWidth <= args.target.clientWidth) {
      args.cancel = true;
    } else {

      grid = this.getActiveGrid();

      switch (this.activeTab) {
        case 'drafts':
          tooltip = this.tooltipDrafts;
          break;
        case 'deliveries':
          tooltip = this.tooltipDeliveries;
          break;
        case 'ERFormGrid':
          tooltip = this.tooltipER;
          break;
      }

      const rowInfo = grid.getRowInfo(args.target);
      const rowData = rowInfo.rowData;
      tooltip.cssClass = 'customTooltip';
      tooltip.content = rowData[(rowInfo.column as any).field];
    }
  }

  // Download spl files
  downloadFile(filePath: string, fileName: string) {

    this.sub = this.orderService.downloadFile(filePath, fileName).subscribe(response => {
      // non-IE
      const URL = window.URL || (<any>window).webkitURL;
      const downloadUrl = URL.createObjectURL(response);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = fileName;
      link.click();
    },
      error => {
        this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
      }
    );
  }

  // Change grid filter operator from "startwith" to "contains" for columns that are string
  public begin(args: any): void {
    if (args.requestType === 'filtering') {
      if (args.columns) {
        args.columns.forEach(col => {
          switch (args.currentFilteringColumn) {
            case 'formVersion':
              args.currentFilterObject.value = `${ args.currentFilterObject.value }.0`;
              break;
            case 'formatedModifiedDate':
              break;
            default:
              col.operator = 'contains';       // set the “contains” operator for the column
              break;
          }
        });
      }
    }
  }

  // Display detail of a single ER form
  viewERForm(erRevisionId: string) {
    if (erRevisionId) {
      this.router.navigate(['/er-form', erRevisionId]);
    }
  }

  // Check if user has write permission. If no, disable the "Save", "Save a draft" buttons
  checkUserPermission() {
    if (this.authorizationService.hasPermission('SSDP.CanWriteERForm')) {
      this.bHasPermission = true;
    }
    if (this.authorizationService.hasPermission('SSDP.CanDeleteERForm')) {
      this.hasDeletePermission = true;
    }
  }

  createCustomToolbarItems(deletePermission: boolean, writePermission: boolean) {
    let toolbarItems = [];

    if (this.activeTab === 'deliveries' && writePermission) {
      toolbarItems.push(
        {
          text: 'Send to FDA',
          tooltipText: 'Send to FDA',
          prefixIcon: 'fas fa-paper-plane',
          id: 'tool-bar-send'
        }
      );
    }

    if (writePermission) {
      toolbarItems.push(
        {
          text: 'Create New ER',
          tooltipText: 'Add a new ER to this list',
          prefixIcon: 'fas fa-plus',
          id: 'create-form-btn'
        }
      );
    }

    if (deletePermission) {
      toolbarItems.push(
        {
          text: 'Delete ER',
          tooltipText: 'Delete the selected ER',
          prefixIcon: 'fas fa-trash',
          id: 'tool-bar-delete'
        }
      )
    }

    if (this.activeTab === 'deliveries' && writePermission) {
      toolbarItems.push(
          {
              text: 'Pragmatic',
              tooltipText: 'Validate the file with Pragmatic',
              prefixIcon: 'fal fa-circle-parking',
              id: 'validation-form-btn'
          }
      );
    }

    toolbarItems.push('Search');

    return toolbarItems;
  }

  onSubmitionToFDA(isSuccessfulySubmitted: boolean) {
    if (isSuccessfulySubmitted) {
      if (this.deliverieGrid) {
        this.deliverieGrid.clearSelection();
      }
    }
  }

  // Grid toolbar click event handler
  toolbarClick(args: ClickEventArgs): void {
    if (args.item.id === 'create-form-btn' && this.bHasPermission) {
      this.router.navigate(["/er-form"]);
    }
    else if (!this.selectedErRevisionId) {
      this.toastr.warning(`No Row(s) selected.`, '', { closeButton: true });
      return;
    }
    else if (args.item.id === 'tool-bar-delete' && this.selectedErRevisionId) {
      if (this.ERForm_grid) {
        this.deleteButton.revisionId = this.selectedErRevisionId.toString();
        this.deleteButton.openDeleteModal();
      }
      else if (this.draftsGrid) {
        this.deleteButtonDrafts.revisionId = this.selectedErRevisionId.toString();
        this.deleteButtonDrafts.openDeleteModal();
      }
      else if (this.deliverieGrid) {
        this.deleteButtonDelivery.revisionId = this.selectedErRevisionId.toString();
        this.deleteButtonDelivery.openDeleteModal();
      }
    }
    else if (this.deliverieGrid && this.selectedERRevisionFileName && args.item.id === 'tool-bar-send') {
      this.sendToFDAButton.showEsignatureModal();
    } else if (this.deliverieGrid && this.selectedERRevisionFileName && args.item.id === 'validation-form-btn') {
      this.pragmaticValidation();
    }
  }

  erFormGridRowSelected(e: any) {
    this.selectedErRevisionId = e.data.erRevisionId;

    this.selectedERRevisionProductType = e.data.documentType;
    this.selectedERRevisionFileName = e.data.fileName;
    this.selectedERRevisionVersion = e.data.formVersion;
  }

  erFormGridRowDeselected() {
    this.selectedErRevisionId = undefined;

    this.selectedERRevisionProductType = undefined;
    this.selectedERRevisionFileName = undefined;
    this.selectedERRevisionVersion = undefined;
  }

  // convenience getter for easy access to form fields
  get f() { return this.searchForm.controls; }

  ngOnDestroy(): void {

    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
  

}
